import gameImage from '../bg-game.png';
import PopupNotificationMessage from '../components/PopupNotification';
import useCustomLogin from '../hook/useLogin';
import { isTelegram } from '../utils/browser';

function Login() {
  const { login } = useCustomLogin();

  if (isTelegram)
    return (
      <div className="App">
        <header className="App-header">
          <div className="Game-container" style={{ position: 'relative' }}>
            <img src={gameImage} alt="game" className="Game-image" />
          </div>
        </header>
        <PopupNotificationMessage />
      </div>
    );

  return (
    <div className="App">
      <header className="App-header">
        <div className="Game-container" style={{ position: 'relative' }}>
          <img src={gameImage} alt="game" className="Game-image" />
        </div>
      </header>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div className="login-wrapper">
          <button onClick={login} className="Play-button">
            <span className="press-start-2p-regular">Log In</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;
